import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { updateProfleAction } from "../../../redux/actions/user/userAction";
import { connect } from "react-redux";
import { DialogLeavingPage } from "../../utils/core/blocknavigation/DialogLeavingPage";
import { useNavigatingAway } from "../../utils/core/blocknavigation/useNavigatingAway";

export const PersonalSkills = (props) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      top: "5px",
      // Overwrittes the different states of border
      borderColor: state.isFocused ? "#309CCA" : "#309CCA",
    }),
  };

  const dispatch = useDispatch();

  const [inputData, setInputData] = useState([]);

  const [isEnable, setIsEnable] = useState({
    save: false,
  });
  const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
    useState(false);
  const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
    useNavigatingAway(canShowDialogLeavingPage);

  const handleChange = (event, eventName) => {
    setIsEnable((prevState) => ({ ...prevState, save: true }));
    setCanShowDialogLeavingPage(true);

    if (event != null) {
      setInputData((prevState) => ({
        ...prevState,
        [eventName]: event["id"],
      }));
    } else {
      setInputData((prevState) => ({ ...prevState, [eventName]: null }));
    }
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const updateSector = {
      id: inputData.id,
      profile: inputData.profile,
      globalFluencyDiversityAwareness:
        inputData.globalFluencyDiversityAwareness,
      accountabilityResponsibility: inputData.accountabilityResponsibility,
      commitment: inputData.commitment,
      abilityIdentify: inputData.abilityIdentify,
      quantativeReasoning: inputData.quantativeReasoning,
      communications: inputData.communications,
      functional: inputData.functional,
      leadership: inputData.leadership,
    };
    const data = {
      userId: props.profile.userId,
      personalSills: [updateSector],
      // skills_score: skillScore(updateSector, props.personalSkills)
    };
    dispatch(updateProfleAction(props.profile.userId, data));
    setIsEnable((prevState) => ({ ...prevState, save: false }));
    setCanShowDialogLeavingPage(false);
  };

  useEffect(() => {
    if (Object.keys(props.profile).length > 0) {
      const userData = {
        id: props.profile.personalSills[0].id,
        profile: props.profile.personalSills[0].profile,
        globalFluencyDiversityAwareness:
          props.profile.personalSills[0].globalFluencyDiversityAwareness,
        accountabilityResponsibility:
          props.profile.personalSills[0].accountabilityResponsibility,
        commitment: props.profile.personalSills[0].commitment,
        abilityIdentify: props.profile.personalSills[0].abilityIdentify,
        quantativeReasoning: props.profile.personalSills[0].quantativeReasoning,
        communications: props.profile.personalSills[0].communications,
        functional: props.profile.personalSills[0].functional,
        leadership: props.profile.personalSills[0].leadership,
      };
      setInputData(userData);
    }
  }, [props.profile, props.personalSkills]);

  return (
    <div className="row margin-row">
      <DialogLeavingPage
        showDialog={showDialogLeavingPage}
        setShowDialog={setCanShowDialogLeavingPage}
        confirmNavigation={confirmNavigation}
        cancelNavigation={cancelNavigation}
        title={"Personal Skill Appraisal"}
      />
      <div className="row-icon">
        <img
          src="\assets\images\profile-page\icon7.png"
          alt=""
        />
        {/* <img
          className="completed"
          src="/assets/images/profile-page/Recent_career_summary_active.svg"
          alt=""
        /> */}
      </div>
      <div className="col-12  ">
        <div className="timeline-border-box">
          <h5>Personal Skill Appraisal</h5>
          <div className="row">
            <div className="col-md-6 col-12" style={{ paddingTop: "1.5%" }}>
              <label className="field-label">
                Global Fluency & Diversity Awareness
              </label>
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <Select
                id="globalFluencyDiversityAwareness"
                name="globalFluencyDiversityAwareness"
                value={
                  props.personalSkills &&
                  props.personalSkills.find(
                    (personalSkills) =>
                      personalSkills.id ===
                      inputData.globalFluencyDiversityAwareness
                  )
                }
                options={props.personalSkills}
                getOptionLabel={(option) => option.personal_skill}
                getOptionValue={(option) => option.id}
                onChange={(event) =>
                  handleChange(event, "globalFluencyDiversityAwareness")
                }
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
              />
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">
                Accountability & Responsibility
              </label>
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <Select
                id="accountabilityResponsibility"
                name="accountabilityResponsibility"
                value={
                  props.personalSkills &&
                  props.personalSkills.find(
                    (personalSkills) =>
                      personalSkills.id ===
                      inputData.accountabilityResponsibility
                  )
                }
                options={props.personalSkills}
                getOptionLabel={(option) => option.personal_skill}
                getOptionValue={(option) => option.id}
                onChange={(event) =>
                  handleChange(event, "accountabilityResponsibility")
                }
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
              />
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">
                Commitment to HSE Principles & Objectives
              </label>
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <Select
                id="commitment"
                name="commitment"
                value={
                  props.personalSkills &&
                  props.personalSkills.find(
                    (personalSkills) =>
                      personalSkills.id === inputData.commitment
                  )
                }
                options={props.personalSkills}
                getOptionLabel={(option) => option.personal_skill}
                getOptionValue={(option) => option.id}
                onChange={(event) => handleChange(event, "commitment")}
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
              />
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">
                Ability to Identify & Source Tech & Procedural Job Related
                Information
              </label>
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <Select
                id="abilityIdentify"
                name="abilityIdentify"
                value={
                  props.personalSkills &&
                  props.personalSkills.find(
                    (personalSkills) =>
                      personalSkills.id === inputData.abilityIdentify
                  )
                }
                options={props.personalSkills}
                getOptionLabel={(option) => option.personal_skill}
                getOptionValue={(option) => option.id}
                onChange={(event) => handleChange(event, "abilityIdentify")}
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
              />
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">
                Quantative Reasoning & Decision Making
              </label>
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <Select
                id="quantativeReasoning"
                name="quantativeReasoning"
                value={
                  props.personalSkills &&
                  props.personalSkills.find(
                    (personalSkills) =>
                      personalSkills.id === inputData.quantativeReasoning
                  )
                }
                options={props.personalSkills}
                getOptionLabel={(option) => option.personal_skill}
                getOptionValue={(option) => option.id}
                onChange={(event) => handleChange(event, "quantativeReasoning")}
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
              />
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">
                Communications (Written & Verbal)
              </label>
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <Select
                id="communications"
                name="communications"
                value={
                  props.personalSkills &&
                  props.personalSkills.find(
                    (personalSkills) =>
                      personalSkills.id === inputData.communications
                  )
                }
                options={props.personalSkills}
                getOptionLabel={(option) => option.personal_skill}
                getOptionValue={(option) => option.id}
                onChange={(event) => handleChange(event, "communications")}
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
              />
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">
                Functional & Category Skills Awareness
              </label>
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <Select
                id="functional"
                name="functional"
                value={
                  props.personalSkills &&
                  props.personalSkills.find(
                    (personalSkills) =>
                      personalSkills.id === inputData.functional
                  )
                }
                options={props.personalSkills}
                getOptionLabel={(option) => option.personal_skill}
                getOptionValue={(option) => option.id}
                onChange={(event) => handleChange(event, "functional")}
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
              />
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">
                Leadership & Supervisory Skills
              </label>
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <Select
                id="leadership"
                name="leadership"
                value={
                  props.personalSkills &&
                  props.personalSkills.find(
                    (personalSkills) =>
                      personalSkills.id === inputData.leadership
                  )
                }
                options={props.personalSkills}
                getOptionLabel={(option) => option.personal_skill}
                getOptionValue={(option) => option.id}
                onChange={(event) => handleChange(event, "leadership")}
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
              />
            </div>
          </div>{" "}
          <br />
          <div className="col text-right ">
            {isEnable.save ? (
              <Link className="edit-btn" to="" onClick={handleFormSubmit}>
                
                <span>
                  <img src="/assets/images/icons/save.png" alt="" />Save
                </span>
              </Link>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const user = state.user.user;
  const profile = state.user.profile;
  const personalSkills = state.admin.personalSkills;

  return {
    user: user,
    profile: profile,
    personalSkills: personalSkills,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PersonalSkills);
